import { useAppStore } from '../store/appStore';
import type { ActionErrorCode } from '../store/actionError';
import './action_error_banner.css';

function messageFor(code: ActionErrorCode, ratingRequired: number | null): string {
  switch (code) {
    case 'not_in_pool':
      return 'Этого заказа нет в списке доставок.';
    case 'locked':
      return 'Заказ пока недоступен.';
    case 'no_passes':
      return 'Недостаточно билетов для повтора.';
    case 'map_locked':
      return ratingRequired != null
        ? `Нужен средний рейтинг ${ratingRequired} для доступа к локации.`
        : 'Локация пока недоступна.';
    case 'vk_unavailable':
      return 'Задание доступно только в мини-приложении ВК.';
    case 'vk_not_configured':
      return 'Сообщество ВК для подписки не настроено.';
    case 'notifications_denied':
      return 'Не удалось включить уведомления.';
    case 'vk_subscribe_failed':
      return 'Не удалось оформить подписку на сообщество.';
    case 'already_claimed':
      return 'Награда за это задание уже получена.';
    case 'save_failed':
      return 'Не удалось сохранить прогресс. Попробуйте ещё раз.';
    default:
      return 'Не удалось выполнить действие.';
  }
}

export function ActionErrorBanner() {
  const code = useAppStore((s) => s.lastActionError);
  const ratingRequired = useAppStore((s) => s.lastActionErrorRatingRequired);
  const clearActionError = useAppStore((s) => s.clearActionError);

  if (code == null) {
    return null;
  }

  return (
    <div className="action-error-banner" role="alert">
      <span className="action-error-banner__text">
        {messageFor(code, ratingRequired)}
      </span>
      <button
        type="button"
        className="action-error-banner__dismiss"
        onClick={() => clearActionError()}
        aria-label="Закрыть"
      >
        ×
      </button>
    </div>
  );
}
